export class Dashboard {
    acilanAcilTalep: number;
    acilanYerelTalep: number;
    acilanSatinAlmaTalep: number;
    sonlananAcilTalep: number;
    sonlananYerelTalep: number;
    sonlananSatinAlmaTalep: number;
    tlAcilTalep: number
    tlYerelTalep: number
    tlSatinAlmaTalep: number


    constructor(obj: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }
}